<template>
  <a-card>
    <div style="float: right;">
      <div class="table-toolbar">
        <a-button type="primary" @click="onEdit">
          <template #icon>
            <form-outlined />
          </template>
        </a-button>
      </div>
    </div>
    <a-descriptions bordered :column="2">
      <template #title>
        <div style="overflow: hidden;">
          <span class="descriptTitleBox">政策兑现公共资料维护</span>
          <!-- <span class="descriptTitleBox"> -->
            <!-- <a @click="getMoban"> 承诺书下载 </a> -->
            <!-- <a> 承诺书下载 </a> -->
          <!-- </span> -->
        </div>
      </template>
      <a-descriptions-item label="营业执照" name="licenceFile" :span="2">
        <file-upload v-model:value="detail.licenceFile" :showBtn="false" disabled />
      </a-descriptions-item>
      <a-descriptions-item label="企业法人身份证(正反面照片放到一张图中)" name="legalPersonCard" :span="2">
        <file-upload v-model:value="detail.legalPersonCard" :showBtn="false" disabled />
      </a-descriptions-item>
      <a-descriptions-item label="开户行许可证" name="bankPermitFile" :span="2">
        <file-upload v-model:value="detail.bankPermitFile" :showBtn="false" disabled />
      </a-descriptions-item>
      <!-- <a-descriptions-item label="承诺书" name="legalPersonCard" :span="2">
        <img-upload v-model:value="detail.legalPersonCard" :showBtn="false" disabled />
      </a-descriptions-item> -->
    </a-descriptions>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getCorpInfo" />
</template>

<script>
import UserModal from './components/UserModal';
import { file_service } from "@/api/adminService";
import { sys_policy } from "@/api/policyService";

export default {
  name: "index",
  mixins: [],
  components: {
    UserModal,
  },
  data() {
    return {
      dictNames: 'businessScope',
      detail: {},
      listKeyField: "id",
    }
  },
  mounted() {
    this.getCorpInfo();
  },
  methods: {
    getCorpInfo() {
      this.getAction({
        url: sys_policy.ziliaoDetail
      }).then(res => {
        this.detail = {
          ...res,
        }
      })
    },
    onEdit() {
      this.onShowModal('userModal', this.detail);
    },
    onShowModal(refName, data = {}) {
      const refEle = this.$refs[refName];
      refEle.form = Object.assign({}, data);
      refEle.visible = true;
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>

<style scoped lang="less">
.descriptTitleBox {
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
  font-size: 16px;
  line-height: 1.5715;
  float: left;
  margin-right: 15px;
}
</style>
